import { useEffect, useRef } from 'react';

import { BackArrow, NextArrow } from 'assets/images';

import './style.scss';

const CARD_STEP = 84; // clamp(38px, 7vw, 80px) + 4px gap, approximate mid-range

const VerticalCarousel = ({ items, activeIndex, setActiveIndex }) => {
  const scrollRef = useRef(null);
  const itemRefs = useRef([]);
  const manualClickRef = useRef(false);

  useEffect(() => {
    if (manualClickRef.current) {
      manualClickRef.current = false;
      return;
    }
    const frameId = requestAnimationFrame(() => {
      const container = scrollRef.current;
      const item = itemRefs.current[activeIndex];
      if (!container || !item) return;
      const containerRect = container.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      container.scrollTo({
        top: container.scrollTop + itemRect.top - containerRect.top - container.clientHeight / 2 + item.clientHeight / 2,
        behavior: 'smooth',
      });
    });
    return () => cancelAnimationFrame(frameId);
  }, [activeIndex]);

  const handleClick = (idx) => {
    manualClickRef.current = true;
    setActiveIndex(idx);
  };

  const scrollUp = () => {
    scrollRef.current?.scrollBy({ top: -CARD_STEP, behavior: 'smooth' });
  };

  const scrollDown = () => {
    scrollRef.current?.scrollBy({ top: CARD_STEP, behavior: 'smooth' });
  };

  return (
    <div className="carousel-col">
      <div className="scroll-btn mb-1" onClick={scrollUp}>
        <img alt="up" src={BackArrow} />
      </div>

      <div className="vertical-carousel" ref={scrollRef}>
        <div className="carousel-track">
          {items?.map((card, idx) => (
            <img
              alt={card?.asset}
              className={`small-img ${activeIndex === idx ? 'active' : ''}`}
              key={card.id}
              onClick={() => handleClick(idx)}
              ref={el => { itemRefs.current[idx] = el; }}
              src={card?.imageUrl}
            />
          ))}
        </div>
      </div>

      <div className="scroll-btn mt-1" onClick={scrollDown}>
        <img alt="down" src={NextArrow} />
      </div>
    </div>
  );
};

export default VerticalCarousel;
